<template>
    <div class="p-4">
        <div class="row justify-content-center text-center">
          <div class="col-lg-6">
            <form  class="php-email-form" v-on:submit.prevent="getAirtimeReports()">
              <div class="newsletter-form"><input type="text" v-model="message.phone" class="newsletter-form-input" placeholder="Enter phonee number"  required disabled>
                <button type="submit" class="newsletter-form-btn" :disabled="loading">
                    <span v-if="!loading">
                    <i class="fa fa-search"></i>
                    </span>
                    <span v-else class="spinner-border spinner-border-sm text-light" role="status"></span>
                </button></div>
            </form>
          </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-sm-8">

<div class="row">

<div
  class="tx-card success col-sm-4"
  v-for="(data, index) in combined"
  :key="index"
  :class="
    data.status === 'PAID' || data.status === 'CONFIRMED'
      ? 'success'
      : data.status === 'FAILED'
        ? 'failed'
        : 'pending'
  "
>
    <div class="tx-left">
        <span
          class="tx-title"
          :class="data.trans === 'purchase' ? 'text-success' : 'text-primary'"
        >
            {{ data.type }}
        </span>
        <span class="tx-date">{{ filerDate(data.created_at) }}</span>
    </div>

    <div class="tx-right">
        <span class="tx-amount">+ KES {{ formatPrice(data.amount) }}</span>
        <span class="tx-status">{{ data.status }}</span>
    </div>

    <!-- 🔽 Bottom row (NEW) -->
    <div class="tx-bottom">
        <span class="tx-meta">
            ID: {{ data.mpesa_ref }}
        </span>
        <span class="tx-meta">
            {{ data.phone }}
        </span>
    </div>
</div>

</div>


            </div>
        </div>
    </div>
</template>
<script>
    import moment from 'moment'
    export default {
        name: 'App',
        components: {

        },
        data(){
            return {
               airtimes:[],
          converted:[],
          combined:[],
               message:{phone:''},
                loading: false,
            }
        },
        created(){
       this.getAirtimeReports();
        },
        methods: {
            getAirtimeReports(){
                this.loading = true;
                let uri =`/api/auth/getAirtimeReports`;
                this.$axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                   this.loading = false;
                    this.airtimes=response.data.airtimes;
                  this.converted=response.data.converted;
                  this.combineTransactions();
                   localStorage.setItem('phone',this.message.phone);
                }).catch(warning => {
                     this.loading = false;
                    if (warning.response.status === 401) {
                    this.$router.push({name: 'auth'});
                     localStorage.removeItem('token');
                     localStorage.removeItem('auth');
                }else{
                   this.$swal({icon: 'warning',title: 'Request failed',text: 'We are unable to complete your request.'});
                }

                });
            },
             combineTransactions(){
              this.combined = [
      ...this.converted.map(tx => ({
        amount: tx.value,
        mpesa_ref: tx.mpesa_ref,
        created_at: tx.created_at,
        type:'Airtime Converted',
        airtime_type:'',
        account:tx.phone,
        status:tx.status,
        trans:'convert',
        phone:tx.phone
      })),
      ...this.airtimes.map(tx => ({
        amount: tx.credit,
        mpesa_ref: tx.mpesa_ref,
        created_at: tx.created_at,
         type:'Airtime Purchased',
          airtime_type:tx.airtime_type,
           account:tx.account,
            status:tx.status,
            trans:'purchase',
            phone:tx.phone
      }))
    ].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

            },

            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', '.');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            filerDate(date){
                return moment(String(date)).format('DD-MM-YYYY hh:mm')
            }

        },
    }

</script>



// WEBPACK FOOTER //
// src/components/history.vue